// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/contactpage.css */

.contactPage {
  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(circle at 20% 18%, rgba(95, 186, 139, 0.16), transparent 28%),
    radial-gradient(circle at 82% 30%, rgba(95, 186, 139, 0.1), transparent 24%),
    linear-gradient(180deg, #f7f5f1 0%, #f3f1ec 48%, #f7f5f1 100%);
  color: #111111;
  overflow: hidden;
}

.contactPage::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.18;
  background-image:
    linear-gradient(rgba(17, 17, 17, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(17, 17, 17, 0.035) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), transparent 85%);
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), transparent 85%);
}

.contactHero {
  position: relative;
  padding: 152px 24px 72px;
}

.contactHero__inner {
  position: relative;
  z-index: 2;
  width: calc(100% - 48px);
  margin: 0 auto;
}

.contactHero__glow {
  position: absolute;
  top: 72px;
  left: 50%;
  width: min(900px, 90vw);
  height: min(420px, 42vw);
  transform: translateX(-50%);
  border-radius: 999px;
  pointer-events: none;
  background:
    radial-gradient(circle at 50% 50%, rgba(95, 186, 139, 0.2), rgba(95, 186, 139, 0.08) 42%, transparent 72%);
  filter: blur(36px);
  opacity: 0.95;
}

.contactHero__eyebrow {
  margin: 0 0 18px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.58);
}

.contactHero__title {
  margin: 0;
  max-width: 8.5ch;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(56px, 8vw, 116px);
  line-height: 0.94;
  font-weight: 700;
  letter-spacing: -0.06em;
  color: #0f0f0f;
}

.contactHero__subtitle {
  margin: 28px 0 0;
  max-width: 760px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(18px, 2vw, 24px);
  line-height: 1.45;
  font-weight: 400;
  color: rgba(17, 17, 17, 0.72);
}

.contactMain {
  position: relative;
  padding: 20px 24px 110px;
}

.contactMain__inner {
  width: min(1200px, calc(100% - 48px));
  margin: 0 auto;
}

.contactMain__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 38px;
  align-items: start;
}

.contactInfo {
  position: relative;
  padding-top: 12px;
}

.contactInfo__label {
  margin: 0 0 20px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.5);
}

.contactInfo__list {
  display: grid;
  gap: 14px;
}

.contactInfoCard {
  position: relative;
  padding: 22px 22px 20px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow:
    0 12px 30px rgba(14, 20, 18, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 0.48);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.contactInfoCard__title {
  margin: 0 0 8px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 22px;
  line-height: 1.1;
  font-weight: 600;
  letter-spacing: -0.04em;
  color: #111111;
}

.contactInfoCard__body {
  margin: 0;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(17, 17, 17, 0.68);
}

.contactFormWrap {
  position: relative;
}

.contactFormGlass {
  position: absolute;
  inset: 18px -10px -18px 18px;
  border-radius: 36px;
  pointer-events: none;
  background:
    radial-gradient(circle at 20% 15%, rgba(255, 255, 255, 0.72), transparent 30%),
    radial-gradient(circle at 82% 22%, rgba(95, 186, 139, 0.22), transparent 28%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.14));
  filter: blur(24px);
  opacity: 0.9;
}

.contactFormCard {
  position: relative;
  z-index: 2;
  padding: 30px;
  border-radius: 32px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.34));
  border: 1px solid rgba(255, 255, 255, 0.62);
  box-shadow:
    0 22px 60px rgba(16, 24, 20, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(22px) saturate(140%);
  -webkit-backdrop-filter: blur(22px) saturate(140%);
}

.contactFormCard__label {
  margin: 0 0 18px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.5);
}

.contactForm {
  display: grid;
  gap: 18px;
}

.contactForm__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.contactField {
  display: grid;
  gap: 8px;
}

.contactField label {
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  color: rgba(17, 17, 17, 0.78);
}

.contactField input,
.contactField select,
.contactField textarea {
  width: 100%;
  border: 1px solid rgba(17, 17, 17, 0.09);
  outline: none;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.65),
    0 1px 2px rgba(17, 17, 17, 0.03);
  padding: 15px 16px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 1.45;
  color: #111111;
  transition:
    border-color 180ms ease,
    box-shadow 180ms ease,
    background 180ms ease,
    transform 180ms ease;
  appearance: none;
  -webkit-appearance: none;
}

.contactField textarea {
  min-height: 160px;
  resize: vertical;
}

.contactField input::placeholder,
.contactField textarea::placeholder {
  color: rgba(17, 17, 17, 0.42);
}

.contactField input:hover,
.contactField select:hover,
.contactField textarea:hover {
  background: rgba(255, 255, 255, 0.84);
  border-color: rgba(17, 17, 17, 0.14);
}

.contactField input:focus,
.contactField select:focus,
.contactField textarea:focus {
  border-color: rgba(95, 186, 139, 0.72);
  background: rgba(255, 255, 255, 0.94);
  box-shadow:
    0 0 0 4px rgba(95, 186, 139, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.78);
}

.contactForm__submit {
  margin-top: 4px;
  min-height: 56px;
  padding: 16px 22px;
  border: 0;
  outline: none;
  border-radius: 999px;
  cursor: pointer;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0c120f;
  background:
    linear-gradient(180deg, rgba(125, 212, 167, 0.98), rgba(95, 186, 139, 0.98));
  box-shadow:
    0 16px 34px rgba(95, 186, 139, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    filter 180ms ease;
}

.contactForm__submit:hover {
  transform: translateY(-1px);
  box-shadow:
    0 20px 40px rgba(95, 186, 139, 0.34),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
  filter: brightness(1.02);
}

.contactForm__submit:active {
  transform: translateY(0);
}

.contactDirect {
  margin-top: 26px;
  padding-top: 22px;
  border-top: 1px solid rgba(17, 17, 17, 0.08);
}

.contactDirect__label {
  margin: 0 0 10px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.48);
}

.contactDirect__links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
}

.contactDirect__links a {
  position: relative;
  text-decoration: none;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 1.4;
  font-weight: 500;
  color: rgba(17, 17, 17, 0.82);
  transition: color 180ms ease, opacity 180ms ease;
}

.contactDirect__links a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 1px;
  background: rgba(95, 186, 139, 0.72);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 180ms ease;
}

.contactDirect__links a:hover {
  color: #111111;
}

.contactDirect__links a:hover::after {
  transform: scaleX(1);
}

.contactClosing {
  padding-top: 52px;
}

.contactClosing p {
  margin: 0;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(28px, 4vw, 56px);
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: rgba(17, 17, 17, 0.92);
}

@media (max-width: 1080px) {
  .contactMain__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .contactInfo {
    order: 2;
  }

  .contactFormWrap {
    order: 1;
  }
}

@media (max-width: 720px) {
  .contactHero {
    padding: 128px 20px 48px;
  }

  .contactMain {
    padding: 8px 20px 84px;
  }

  .contactHero__inner,
  .contactMain__inner {
    width: min(1200px, calc(100% - 24px));
  }

  .contactHero__title {
    max-width: 10ch;
    font-size: clamp(46px, 14vw, 72px);
  }

  .contactHero__subtitle {
    margin-top: 22px;
    font-size: 18px;
  }

  .contactFormCard {
    padding: 22px;
    border-radius: 26px;
  }

  .contactForm__row {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .contactInfoCard {
    padding: 20px 18px 18px;
    border-radius: 20px;
  }

  .contactDirect__links {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .contactClosing {
    padding-top: 36px;
  }
}

@media (max-width: 480px) {
  .contactHero {
    padding-top: 116px;
  }

  .contactHero__eyebrow,
  .contactInfo__label,
  .contactFormCard__label,
  .contactDirect__label {
    font-size: 11px;
  }

  .contactField input,
  .contactField select,
  .contactField textarea {
    border-radius: 16px;
    padding: 14px 14px;
    font-size: 14px;
  }

  .contactForm__submit {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contactpage.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,kBAAkB;EAClB,iBAAiB;EACjB;;;kEAGgE;EAChE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;wEAEsE;EACtE,0BAA0B;EAC1B,4EAA4E;EAC5E,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB;8GAC4G;EAC5G,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gDAAgD;EAChD,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C;;2CAEyC;EACzC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB;;;gFAG8E;EAC9E,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB;iFAC+E;EAC/E,2CAA2C;EAC3C;;2CAEyC;EACzC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC;;oCAEkC;EAClC,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd;;;;wBAIsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;;;EAGE,sCAAsC;EACtC,qCAAqC;EACrC;;2CAEyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd;gFAC8E;EAC9E;;0CAEwC;EACxC;;;qBAGmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B;;2CAEyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* src/components/contactpage.css */\n\n.contactPage {\n  position: relative;\n  min-height: 100vh;\n  background:\n    radial-gradient(circle at 20% 18%, rgba(95, 186, 139, 0.16), transparent 28%),\n    radial-gradient(circle at 82% 30%, rgba(95, 186, 139, 0.1), transparent 24%),\n    linear-gradient(180deg, #f7f5f1 0%, #f3f1ec 48%, #f7f5f1 100%);\n  color: #111111;\n  overflow: hidden;\n}\n\n.contactPage::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.18;\n  background-image:\n    linear-gradient(rgba(17, 17, 17, 0.035) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(17, 17, 17, 0.035) 1px, transparent 1px);\n  background-size: 40px 40px;\n  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), transparent 85%);\n  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), transparent 85%);\n}\n\n.contactHero {\n  position: relative;\n  padding: 152px 24px 72px;\n}\n\n.contactHero__inner {\n  position: relative;\n  z-index: 2;\n  width: calc(100% - 48px);\n  margin: 0 auto;\n}\n\n.contactHero__glow {\n  position: absolute;\n  top: 72px;\n  left: 50%;\n  width: min(900px, 90vw);\n  height: min(420px, 42vw);\n  transform: translateX(-50%);\n  border-radius: 999px;\n  pointer-events: none;\n  background:\n    radial-gradient(circle at 50% 50%, rgba(95, 186, 139, 0.2), rgba(95, 186, 139, 0.08) 42%, transparent 72%);\n  filter: blur(36px);\n  opacity: 0.95;\n}\n\n.contactHero__eyebrow {\n  margin: 0 0 18px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(17, 17, 17, 0.58);\n}\n\n.contactHero__title {\n  margin: 0;\n  max-width: 8.5ch;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(56px, 8vw, 116px);\n  line-height: 0.94;\n  font-weight: 700;\n  letter-spacing: -0.06em;\n  color: #0f0f0f;\n}\n\n.contactHero__subtitle {\n  margin: 28px 0 0;\n  max-width: 760px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(18px, 2vw, 24px);\n  line-height: 1.45;\n  font-weight: 400;\n  color: rgba(17, 17, 17, 0.72);\n}\n\n.contactMain {\n  position: relative;\n  padding: 20px 24px 110px;\n}\n\n.contactMain__inner {\n  width: min(1200px, calc(100% - 48px));\n  margin: 0 auto;\n}\n\n.contactMain__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 38px;\n  align-items: start;\n}\n\n.contactInfo {\n  position: relative;\n  padding-top: 12px;\n}\n\n.contactInfo__label {\n  margin: 0 0 20px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(17, 17, 17, 0.5);\n}\n\n.contactInfo__list {\n  display: grid;\n  gap: 14px;\n}\n\n.contactInfoCard {\n  position: relative;\n  padding: 22px 22px 20px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.42);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  box-shadow:\n    0 12px 30px rgba(14, 20, 18, 0.06),\n    inset 0 1px 0 rgba(255, 255, 255, 0.48);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n}\n\n.contactInfoCard__title {\n  margin: 0 0 8px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 22px;\n  line-height: 1.1;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n  color: #111111;\n}\n\n.contactInfoCard__body {\n  margin: 0;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  line-height: 1.55;\n  color: rgba(17, 17, 17, 0.68);\n}\n\n.contactFormWrap {\n  position: relative;\n}\n\n.contactFormGlass {\n  position: absolute;\n  inset: 18px -10px -18px 18px;\n  border-radius: 36px;\n  pointer-events: none;\n  background:\n    radial-gradient(circle at 20% 15%, rgba(255, 255, 255, 0.72), transparent 30%),\n    radial-gradient(circle at 82% 22%, rgba(95, 186, 139, 0.22), transparent 28%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.14));\n  filter: blur(24px);\n  opacity: 0.9;\n}\n\n.contactFormCard {\n  position: relative;\n  z-index: 2;\n  padding: 30px;\n  border-radius: 32px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.34));\n  border: 1px solid rgba(255, 255, 255, 0.62);\n  box-shadow:\n    0 22px 60px rgba(16, 24, 20, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(22px) saturate(140%);\n  -webkit-backdrop-filter: blur(22px) saturate(140%);\n}\n\n.contactFormCard__label {\n  margin: 0 0 18px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(17, 17, 17, 0.5);\n}\n\n.contactForm {\n  display: grid;\n  gap: 18px;\n}\n\n.contactForm__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.contactField {\n  display: grid;\n  gap: 8px;\n}\n\n.contactField label {\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.2;\n  font-weight: 600;\n  color: rgba(17, 17, 17, 0.78);\n}\n\n.contactField input,\n.contactField select,\n.contactField textarea {\n  width: 100%;\n  border: 1px solid rgba(17, 17, 17, 0.09);\n  outline: none;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.72);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.65),\n    0 1px 2px rgba(17, 17, 17, 0.03);\n  padding: 15px 16px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  line-height: 1.45;\n  color: #111111;\n  transition:\n    border-color 180ms ease,\n    box-shadow 180ms ease,\n    background 180ms ease,\n    transform 180ms ease;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.contactField textarea {\n  min-height: 160px;\n  resize: vertical;\n}\n\n.contactField input::placeholder,\n.contactField textarea::placeholder {\n  color: rgba(17, 17, 17, 0.42);\n}\n\n.contactField input:hover,\n.contactField select:hover,\n.contactField textarea:hover {\n  background: rgba(255, 255, 255, 0.84);\n  border-color: rgba(17, 17, 17, 0.14);\n}\n\n.contactField input:focus,\n.contactField select:focus,\n.contactField textarea:focus {\n  border-color: rgba(95, 186, 139, 0.72);\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow:\n    0 0 0 4px rgba(95, 186, 139, 0.16),\n    inset 0 1px 0 rgba(255, 255, 255, 0.78);\n}\n\n.contactForm__submit {\n  margin-top: 4px;\n  min-height: 56px;\n  padding: 16px 22px;\n  border: 0;\n  outline: none;\n  border-radius: 999px;\n  cursor: pointer;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #0c120f;\n  background:\n    linear-gradient(180deg, rgba(125, 212, 167, 0.98), rgba(95, 186, 139, 0.98));\n  box-shadow:\n    0 16px 34px rgba(95, 186, 139, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n  transition:\n    transform 180ms ease,\n    box-shadow 180ms ease,\n    filter 180ms ease;\n}\n\n.contactForm__submit:hover {\n  transform: translateY(-1px);\n  box-shadow:\n    0 20px 40px rgba(95, 186, 139, 0.34),\n    inset 0 1px 0 rgba(255, 255, 255, 0.45);\n  filter: brightness(1.02);\n}\n\n.contactForm__submit:active {\n  transform: translateY(0);\n}\n\n.contactDirect {\n  margin-top: 26px;\n  padding-top: 22px;\n  border-top: 1px solid rgba(17, 17, 17, 0.08);\n}\n\n.contactDirect__label {\n  margin: 0 0 10px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(17, 17, 17, 0.48);\n}\n\n.contactDirect__links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 20px;\n}\n\n.contactDirect__links a {\n  position: relative;\n  text-decoration: none;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  line-height: 1.4;\n  font-weight: 500;\n  color: rgba(17, 17, 17, 0.82);\n  transition: color 180ms ease, opacity 180ms ease;\n}\n\n.contactDirect__links a::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -3px;\n  width: 100%;\n  height: 1px;\n  background: rgba(95, 186, 139, 0.72);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 180ms ease;\n}\n\n.contactDirect__links a:hover {\n  color: #111111;\n}\n\n.contactDirect__links a:hover::after {\n  transform: scaleX(1);\n}\n\n.contactClosing {\n  padding-top: 52px;\n}\n\n.contactClosing p {\n  margin: 0;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(28px, 4vw, 56px);\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: rgba(17, 17, 17, 0.92);\n}\n\n@media (max-width: 1080px) {\n  .contactMain__grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .contactInfo {\n    order: 2;\n  }\n\n  .contactFormWrap {\n    order: 1;\n  }\n}\n\n@media (max-width: 720px) {\n  .contactHero {\n    padding: 128px 20px 48px;\n  }\n\n  .contactMain {\n    padding: 8px 20px 84px;\n  }\n\n  .contactHero__inner,\n  .contactMain__inner {\n    width: min(1200px, calc(100% - 24px));\n  }\n\n  .contactHero__title {\n    max-width: 10ch;\n    font-size: clamp(46px, 14vw, 72px);\n  }\n\n  .contactHero__subtitle {\n    margin-top: 22px;\n    font-size: 18px;\n  }\n\n  .contactFormCard {\n    padding: 22px;\n    border-radius: 26px;\n  }\n\n  .contactForm__row {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .contactInfoCard {\n    padding: 20px 18px 18px;\n    border-radius: 20px;\n  }\n\n  .contactDirect__links {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .contactClosing {\n    padding-top: 36px;\n  }\n}\n\n@media (max-width: 480px) {\n  .contactHero {\n    padding-top: 116px;\n  }\n\n  .contactHero__eyebrow,\n  .contactInfo__label,\n  .contactFormCard__label,\n  .contactDirect__label {\n    font-size: 11px;\n  }\n\n  .contactField input,\n  .contactField select,\n  .contactField textarea {\n    border-radius: 16px;\n    padding: 14px 14px;\n    font-size: 14px;\n  }\n\n  .contactForm__submit {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
